import React from 'react'
import { useHistory } from 'react-router'
import moment from 'moment'

// styles
import './JobDaysForDate.css'

// utils
import { createJobDayCards } from './JobDaysForDate.collection.utils'

// graphql
import { useQuery } from '@apollo/client'
import { GET_ALL_JOB_DAYS_FOR_DATE } from '../../../../../graphql/jobDay/jobDay.queries'

// components
import FourSectionCardListItem from '../../../../../components/collections/FourSectionCardListItem/FourSectionCardListItem.component'

// mui
import { Typography, Container, Grid } from '@mui/material'

export default function JobDaysForDate({ date }) {

    const history = useHistory()

    let cards = []

    const { data } = useQuery(GET_ALL_JOB_DAYS_FOR_DATE, {
        variables: { date }
    })

    if(data && data.jobDaysForForemanForDate) {
        cards = [...createJobDayCards(data.jobDaysForForemanForDate)]
    }

    if(cards.length == 0) { return null }

    return (<Container disableGutters sx={{ marginBottom: 8 }}>

        <Grid container spacing={2}>
            <Grid item xs={4}><Typography variant="h5">{moment(date).format("MM/DD/YYYY")}</Typography></Grid>
            <Grid item container xs={8} direction='column'>
            {
                cards.map(card => {
                    return (<FourSectionCardListItem 
                        mainTitle={card.job.name}
                        subTitle={`${card.startTime} - ${card.endTime ? card.endTime : ""}`}
                        leftData={[`${card.job.street1}`, `${card.job.city}${card.job.city ? ',' : ''} ${card.job.state} ${card.job.zipcode}`]}
                        rightData={`${card.numCrewMembers} Crew Member${card.numCrewMembers !== 1 ? 's' : 0}`}
                        onClick={() => history.push(`/schedule/details/${card.id}`)} 
                    />)
                })
            }
            </Grid>
        </Grid>
    

        
        
        
        </Container>)
}